import { GeographyUnitType } from "@shared/clients/api.generated";

export interface Breadcrumb {
  label: string;
  longLabel?: string;
  url: string;
  type: BreadcrumbType;
}

export enum BreadcrumbType {
  GeneralElection = "GeneralElection",
  RegionalElection = "RegionalElection",
  MunicipalElection = "MunicipalElection",
  EuropeanParliamentElection = "EuropeanParliamentElection",
  Referendum = "Referendum",
  NominationDistrict = "NominationDistrict",
  PollingDistrict = "PollingDistrict",
  Municipality = "Municipality",
  Region = "Region",
  Page = "Page"
}

export const BreadcrumbElectionTypes = [ BreadcrumbType.GeneralElection, BreadcrumbType.RegionalElection,
  BreadcrumbType.MunicipalElection, BreadcrumbType.EuropeanParliamentElection, BreadcrumbType.Referendum ]
  
export const BreadcrumbGeographyTypes = [ BreadcrumbType.NominationDistrict, BreadcrumbType.PollingDistrict,
  BreadcrumbType.Municipality, BreadcrumbType.Region ]

export function getGeographyUnitType(breadcrumbType: BreadcrumbType) {
  switch (breadcrumbType) {
    case BreadcrumbType.Municipality: return GeographyUnitType.Municipality;
    case BreadcrumbType.Region: return GeographyUnitType.Region;
    case BreadcrumbType.NominationDistrict: return GeographyUnitType.NominationDistrict;
    case BreadcrumbType.PollingDistrict: return GeographyUnitType.PollingDistrict;
  }
  return undefined;
}
